import { EventAttributes, EventState } from '@/types'
import { CreateEventMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect, useMemo } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()
  const d = useMemo(() => new Date, [])

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData,
  } = useForm<CreateEventMutation, EventAttributes, never, never>({
    defaultValues: {
      description: '',
      details: '',
      dateOut: d,
      dateStart: d,
      dateEnd: d,
      dateReturn: d ,
      state: EventState.Pending,
      clientId: '',
      venueId: '',
      warehouseId: ''
    },
    mutation: CreateMutation,
    resultKey: 'createEvent',
    refetchQueries: [TableQuery]
  })

  // useEffect(() => {
  //   if (attributes.dateOut !== d) {
  //     setAttributes(attributes => {
  //       const attrs = { ...attributes }
  //       if (attributes.dateStart !== attributes.dateOut) attrs.dateStart = attributes.dateOut
  //       if (attributes.dateEnd !== attributes.dateOut) attrs.dateEnd = attributes.dateOut
  //       if (attributes.dateReturn !== attributes.dateOut) attrs.dateReturn = attributes.dateOut
  //       return attrs
  //     })
  //   }
  // }, [attributes, setAttributes, d])

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createEvent?.event?.id) return

    navigate(`/events/${mutationData?.createEvent?.event?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Client', field: 'clientId', type: 'client' }) }
      { formBuilder.buildField({ name: 'Venue', field: 'venueId', type: 'venue' }) }
      { formBuilder.buildField({ name: 'Warehouse', field: 'warehouseId', type: 'warehouse' }) }
      { formBuilder.buildField({ name: 'Description', field: 'description', type: 'text' }) }
      { formBuilder.buildField({ name: 'Details', field: 'details', type: 'textarea' }) }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Date out', field: 'dateOut', type: 'datetime' }) }
        { formBuilder.buildField({ name: 'Date start', field: 'dateStart', type: 'datetime' }) }
        { formBuilder.buildField({ name: 'Date finish', field: 'dateEnd', type: 'datetime' }) }
        { formBuilder.buildField({ name: 'Date return', field: 'dateReturn', type: 'datetime' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
